import { render } from "./Stair.vue?vue&type=template&id=bc93ff98&scoped=true"
import script from "./Stair.vue?vue&type=script&lang=js"
export * from "./Stair.vue?vue&type=script&lang=js"

import "./Stair.vue?vue&type=style&index=0&id=bc93ff98&lang=scss&scoped=true"

import exportComponent from "/opt/web_acelerometrica_publica/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc93ff98"]])

export default __exports__